import { Module } from 'vuex'
import actions from '@/modules/common/store/entityActions'
import EntityState from '@/modules/common/store/entityState'
import getters from '@/modules/common/store/entityGetters'
import ItemDispatch from '@/modules/item/domain/ItemDispatch'
import itemDispatchService from '@/modules/item/service/itemDispatchService'
import mutations from '@/modules/common/store/entityMutations'
import RootState from '@/store/rootState'

const contactModule: Module<EntityState<ItemDispatch>, RootState> = {
  namespaced: true,
  state: new EntityState(),
  mutations,
  getters,
  actions: actions(itemDispatchService, 'item-dispatch')
}

export default contactModule
